// import React, { useState } from 'react';
// import $ from 'jquery';

// const ProductModal = ({setProducts, setFilteredProducts, selectedProduct, setSelectedProduct, products}) => {

//   const handleConfirmDelete = () => {
//     if (selectedProduct) {
//       // Remove the product from the products array
//       const updatedProducts = products.filter(
//         (product) => product.id !== selectedProduct.id
//       );

//       setProducts(updatedProducts);
//       setFilteredProducts(updatedProducts);
//       setSelectedProduct(null);

//       //  close modal
//       $('#deleteProductModal').modal('hide');

//     } else {
//       // Handle the case where no product is selected
//       console.error("No product selected for deletion.");
//     }
//   };

//   return (
//     <>
//       <div className="modal fade" id="addProductModal" tabIndex="-1" aria-labelledby="addProductModalLabel" aria-hidden="true">
//         <div className="modal-dialog">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title" id="addProductModalLabel">Add Product</h5>
//               <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
//             </div>
//             <div className="modal-body">
//               {/* Add Product Form */}
//             </div>
//             <div className="modal-footer">
//               <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
//               <button type="button" className="btn btn-primary">Save changes</button>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="modal fade" id="editProductModal" tabIndex="-1" aria-labelledby="editProductModalLabel" aria-hidden="true">
//         <div className="modal-dialog">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title" id="editProductModalLabel">Edit Product</h5>
//               <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
//             </div>
//             <div className="modal-body">
//               {/* Edit Product Form */}
//             </div>
//             <div className="modal-footer">
//               <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
//               <button type="button" className="btn btn-primary">Save changes</button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* delete modal */}
//       <div className="modal fade" id="deleteProductModal" tabIndex="-1" aria-labelledby="deleteProductModalLabel" aria-hidden="true">
//         <div className="modal-dialog">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title" id="deleteProductModalLabel">Delete Product</h5>
//               <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
//             </div>
//             <div className="modal-body">
//               Are you sure you want to delete this product?
//             </div>
//             <div className="modal-footer">
//               <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
//               <button type="button" className="btn btn-danger" onClick={() => handleConfirmDelete()}>Delete</button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ProductModal;

import React, { useState, useEffect } from "react";

const ProductModal = ({ type, product, onDelete, onSave }) => {
  const [productData, setProductData] = useState({
    id: null,
    image: "",
    name: "",
    description: "",
    price: "",
    category: "",
    stock: "",
  });

  useEffect(() => {
    if (product) {
      setProductData(product);
    }
  }, [product]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductData({ ...productData, [name]: value });
  };

  const handleSaveChanges = () => {
    onSave(productData);
    setProductData({
      id: null,
      image: "",
      name: "",
      description: "",
      price: "",
      category: "",
      stock: "",
    });
  };

  const handleConfirmDelete = () => {
    onDelete(product);
  };

  return (
    <>
      {type === "edit" ? (
        <div
          className="modal fade"
          id="productModal"
          tabIndex="-1"
          aria-labelledby="productModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="productModalLabel">
                  {type === "add" ? "Add Product" : "Edit Product"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label htmlFor="productImage" className="form-label">
                      Image
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      id="productImage"
                      name="image"
                      // value={productData?.image}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="productName" className="form-label">
                      Product Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="productName"
                      name="name"
                      placeholder={productData.name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="productDescription" className="form-label">
                      Description
                    </label>
                    <textarea
                      className="form-control"
                      id="productDescription"
                      name="description"
                      placeholder={productData.description}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="productPrice" className="form-label">
                      Price
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="productPrice"
                      name="price"
                      value={productData.price}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="productCategory" className="form-label">
                      Category
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="productCategory"
                      name="category"
                      placeholder={productData.category.name}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="productStock" className="form-label">
                      Stock
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="productStock"
                      name="stock"
                      placeholder={productData.stock}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3"></div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSaveChanges}
                >
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : type === "delete" ? (
        <div
          className="modal fade"
          id="productModal"
          tabIndex="-1"
          aria-labelledby="deleteProductModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="deleteProductModalLabel">
                  Delete Product
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                Are you sure you want to delete this product?
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={handleConfirmDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default ProductModal;
